'use client'

import * as React from 'react'
import { FormItemContextValue } from '../../types/FormItemContextValue'

/**
 * @group Contexts
 * 
 * @summary
 * <blockquote>Context to provide id to form-related components within a form item.</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormItemContext } from '@shared/ui'
 * 
 * const itemContext = React.useContext(FormItemContext)
 * ```
 */
export const FormItemContext = React.createContext<FormItemContextValue>(
  {} as FormItemContextValue
) 